<template>
  <div class="dual-axes-skeleton">
    <SkeletonHeader />
    <div class="dual-axes-skeleton__column-list">
      <div
        v-for="(h, key) in columnsHeight"
        :key="key"
        class="dual-axes-skeleton__column"
        :style="{ height: `${h}px` }"
      />
    </div>
  </div>
</template>

<script>
import { SkeletonHeader } from '@/components/base';

export default {
  name: 'DualAxesLineAndColumnSkeleton',
  components: {
    SkeletonHeader,
  },
  data() {
    return {
      columnsHeight: [
        442,
        291,
        366,
        141,
        287,
        301,
        297,
        67,
        291,
        366,
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.dual-axes-skeleton {
  &__column-list {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 48px;
    border-bottom: 1px solid var(--ds-color-overlay);
  }

  &__column {
    display: inline-block;
    width: 79px;
    height: 242px;
    background: linear-gradient(180deg, rgba(237, 237, 237, 0) 0%, #d2d2d4 100%);
    position: relative;
    overflow: hidden;

    &::after {
      animation: vertical-loading 1.5s infinite;
      content: '';
      width: 100%;
      height: 100%;
      z-index: 1;
      position: absolute;
      left: 0;
      bottom: 0;
      transform: translateY(100%);
      background: linear-gradient(180deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0));
    }
  }
}

@keyframes vertical-loading {
  100% {
    transform: translateY(-100%);
  }
}
</style>
